import { wnbAddress } from "./config";

export default function(addressName) {
  const subPath = [];
  subPath["LOGOUT"] = "logout";
  subPath["LOGIN"] = "login";
  subPath["FLIGHT_SEARCH"] = "flightsSearch";
  subPath["HOTEL_SEARCH"] = "hotelsSearch";
  subPath["MY_COMPANY"] = "company";
  subPath["USER"] = "users";
  subPath["BOOKING"] = "bookings";
  subPath["REPORT"] = "reports";
  subPath["SEARCH"] = "search";
  subPath["ACCOUNT_SETTINGS"] = "settings";
  return wnbAddress + subPath[addressName];
}
